import React from "react";
import { Hymn } from "../../pages/pray/hymns";
import { useSettings } from "../../utils/settings";

import { getTransposeByFromMode } from "../eb-chant/note-utils";
import { getNotesFromString } from "../utils";
import { PlayButton } from "./PlayButton";

export const HymnPlayer: React.FC<{
    hymn: Hymn;
}> = (props) => {
    const { hymn } = props;

    const verseCount = hymn.text.length / hymn.tune.length;

    const score: string[] = [
        getNotesFromString(hymn.tune[0][0])[0] + ".",
        ",",
        ",",
    ];

    for (let v = 0; v < verseCount; v++) {
        hymn.tune.forEach((line, lineIndex) => {
            line.forEach((syllable, syllableIndex) => {
                getNotesFromString(syllable).forEach((note, noteIndex) => {
                    if (
                        syllableIndex === line.length - 1 &&
                        (noteIndex === syllable.length - 1 ||
                            syllable.length === 2)
                    ) {
                        score.push(note + ".");
                    } else {
                        score.push(note);
                    }
                });
            });
            if (lineIndex % 2 === 1) {
                score.push(",", ",");
            } else {
                score.push(",");
            }
        });

        if (v < verseCount - 1) {
            score.push(",", ",");
        }
    }

    getNotesFromString(hymn.amen[0])
        .map((note, noteIndex) =>
            noteIndex === hymn.amen[0].length - 1 ? `${note}.` : note
        )
        .forEach((note) => score.push(note));
    getNotesFromString(hymn.amen[1])
        .map((note, noteIndex) =>
            noteIndex === hymn.amen[1].length - 1 ? `${note}.` : note
        )
        .forEach((note) => score.push(note));

    const { settings } = useSettings();

    const transposeBy = settings.transpositions[hymn.tone];

    return (
        <>
            <PlayButton
                clef={hymn.clef}
                score={score}
                title={"Play full hymn"}
                transposeBy={
                    (transposeBy ?? 0) + getTransposeByFromMode(hymn.tone)
                }
            />
        </>
    );
};
